/**
 * OpenAPI definition
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * Link creation request
 */
export interface GoldenTransferLinkCreation {
  address: string;
  assetId?: number;
  network: GoldenTransferLinkCreation.NetworkEnum;
  accountId: number;
  allowWithdraw: boolean;
  autoBook: boolean;
}
export namespace GoldenTransferLinkCreation {
  export const NetworkEnum = {
    Trc20: 'TRC20',
    Erc20: 'ERC20',
    Bank: 'BANK',
    Tassat: 'TASSAT',
    MaticErc20: 'MATIC_ERC20',
  } as const;
  export type NetworkEnum = (typeof NetworkEnum)[keyof typeof NetworkEnum];
}
